import React from 'react';
import { DescriptionProps } from '@/components/serialize-description/types';
import { serializeToHTML } from '@/utils/serialize';
import clsx from 'clsx';

const SerializeDescription: React.FC<DescriptionProps> = ({
  description,
  className,
}) => {
  const htmlContent = serializeToHTML(description);

  return (
    <div
      className={clsx('flex flex-col gap-4', className)}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
};

export default SerializeDescription;
